<template>
  <img :src="images[name]" :height="size" />
</template>

<script>
import alert from '../assets/images/alert-circle.svg';
import check from '../assets/images/check-badge.svg';
import cta from '../assets/images/cta-arrow.svg';
import left from '../assets/images/left-arrow.svg';
import right from '../assets/images/right-arrow.svg';
import locked from '../assets/images/locked.svg';
import smiley from '../assets/images/smiley-sad.svg';

export default {
  name: 'Icon',
  data() {
    return {
      images: {
        alert,
        check,
        cta,
        left,
        right,
        locked,
        smiley,
      },
    };
  },
  props: {
    size: {
      type: [Number, String],
      default: 24,
    },
    name: {
      type: String,
      default: 'alert',
    },
  },
};
</script>

<style scoped></style>
